import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import styles from './carousel.module.scss';
const CarouselItems = ({ activePage = 0, carouselItems, children, direction, height, totalItems, width, }) => {
    const carouselStyle = useMemo(() => {
        return {
            transform: direction === 'horizontal'
                ? `translateX(-${width * activePage}px)`
                : `translateY(-${height * activePage}px)`,
            width: `${width * totalItems}px`,
        };
    }, [width, height, activePage]);
    return (_jsx("ul", { className: styles.carousel, style: carouselStyle, role: "list", children: carouselItems.map((item, index) => (_jsx("li", { className: styles.item, role: "listitem", "data-visible": activePage === index, "aria-hidden": activePage !== index, style: {
                left: direction === 'horizontal' ? item.left : 0,
                top: direction === 'horizontal' ? 0 : item.top,
                visibility: item.width === 0 ? 'hidden' : 'visible',
                width: item.width,
            }, children: _jsx("div", { className: styles.item_container, children: children[index] }) }, item.id))) }));
};
CarouselItems.displayName = 'CarouselItems';
export { CarouselItems };
